import React from "react";
import "./Dashboard.css";

/**
 * DashboardStatsSkeleton - Skeleton loader for stat cards
 *
 * @param {object} props - Component props
 * @param {number} [props.count=4] - Number of skeleton cards to display
 * @param {string} [props.className] - Optional additional class names
 */
const DashboardStatsSkeleton = ({ count = 4, className = "" }) => {
  return (
    <div className={`row mb-4 ${className}`}>
      {Array.from({ length: count }).map((_, index) => (
        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-3" key={index}>
          <div className="dashboard-stat-card dashboard-stat-card-skeleton">
            <div className="dashboard-stat-icon">
              <div className="skeleton-icon"></div>
            </div>
            <div className="dashboard-stat-content">
              <div className="skeleton-label"></div>
              <div className="skeleton-value"></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardStatsSkeleton;
